import { WMSListServices } from './WMSListServices';
import { useWMSSettings } from '../../WMSLayers/useWMSSettings';
import { useLocalization } from '@ais-ui/locale-management';

export function WMSForm() {
  const { messages } = useLocalization();
  const wmsSettings = useWMSSettings();

  return (
    <div className="space-y-8">
      <WMSListServices />
    </div>
  );
}
